// This enum must match the same enum in api and DB
export enum BusinessOperation{
  ViewProject = 1,
  CreateProject = 2,
  ModifyProject = 3,
  DeleteProject = 4,
  ExportProject = 5,

  ViewProjectInvoice = 11,
  CreateProjectInvoice = 12,
  DeleteProjectInvoice = 13,

  ViewTimeSheet = 21,
  EnterTimeSheet = 22,
  ModifyTimeSheet = 23,
  UpdatePastTimeSheet = 24,
  ExportTimeSheet = 25,
  GenerateTimeSheet = 26,

  ViewRoster = 31,
  ModifyRoster = 32,
  PrintDailySignonSheet = 33,
  ManageRosterSetting = 35,
  ExportRoster = 36,

  ViewEmployee = 41,
  AddEmployee = 42,
  ModifyEmployee = 43,
  ExportEmployee = 44,
  UpdateEmployeeRosterSortNo = 45,
  ManageEmployeeTrainingRecord = 46,

  ViewPayrollTimesheet = 51,
  ModifyPayrollTimesheet = 52,
  DeletePayrollTimesheet = 53,
  ExportPayrollTimesheet = 54,

  ExportPoInvoiceDiscrepancyReport = 100,
  GenerateMonthlyIncomeReport = 101,

  ManageArea = 110,
  ManageClientEngineer = 111,
  ManageWorkGroup = 112,
  ManageJobPosition = 113,
  ManagePayCategory = 114,
  ManageTimesheetBreakDownRule = 115,
  ManageRosterCode = 116,
  ManageHoliday = 117,
  ManageRosterProject = 118,
  ManageRosterProjectPermission = 119,
  ManageProjectColumn = 120,
  ManageTrainingCourse = 121,
  ManageEmployer = 122,
  
  ViewLinks = 130,
  ManageLinks = 131,

  ManageAllAccount = 140,
  ManageOwnProfile = 141,
  ManageOwnPassword = 142,
  ImportRoster = 143
}
